// extracted by mini-css-extract-plugin
module.exports = {"search-send-button__button":"SearchSendButton_search-send-button__button__AdK8A"};